<template>
  <div>
    <CommonDialog
      :dialog="dialog"
      :head-text="$t('logout.dialog-title')"
      :content-text="$t('logout.dialog-text')"
      :confirm-button="{
        text: $t('logout.logout'),
        icon: 'mdi-logout'
      }"
      :on-confirm="logout"
      :on-cancel="goBack"
    ></CommonDialog>
    <BackButton ref="back" defaultRouter="/" v-show="false"></BackButton>
  </div>
</template>

<script>
import CommonDialog from "../components/common/dialogs/CommonDialog";
import BackButton from "../components/common/buttons/BackButton";
export default {
  name: "Logout",
  components: { CommonDialog, BackButton },
  data: () => ({
    dialog: true
  }),
  methods: {
    logout() {
      this.$store.dispatch("sessionStore/logout");
    },
    goBack() {
      this.$refs.back.goBack();
    }
  }
};
</script>

<style scoped></style>
